"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyClassDropdown = exports.default = void 0;
var taxonomy_class_dropdown_1 = require("./taxonomy-class-dropdown");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(taxonomy_class_dropdown_1).default; } });
Object.defineProperty(exports, "TaxonomyClassDropdown", { enumerable: true, get: function () { return taxonomy_class_dropdown_1.TaxonomyClassDropdown; } });
